<template>
  <div class="content">
    <vue-snotify></vue-snotify>
    <simplert></simplert>
    <navbar></navbar>
    <div class="content">
      <div class="content-wrapper">
        <div class="content-body">
          <breadcrumb></breadcrumb>
          <router-view>
          </router-view>
        </div>
      </div>
    </div>
    <!-- Google Dialogflow -->
    <df-messenger
      project-id="projeto-teste-gemini"
      agent-id="aa3f0809-1298-4d4d-9a4c-438a8474edef"
      language-code="pt"
      max-query-length="-1"
      allow-feedback="all"
    >
      <df-messenger-chat-bubble chat-title="Agente iSend">
      </df-messenger-chat-bubble>
    </df-messenger>
  </div>
</template>

<script>
export default {
name: "Admin.vue"
}
</script>

<style>
df-messenger {
    z-index: 999;
    position: fixed;
    bottom: 60px;
    right: 16px;
}
</style>
